import { isSalesforceOpportunityId } from '~/utils/validateSalesforceId';

const BEDBANK_OFFER_ID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;

export function getAdminOfferUrl(offerId: string): string {
  if (BEDBANK_OFFER_ID_PATTERN.test(offerId)) {
    return `/bedbank/properties/${offerId}`;
  }
  if (isSalesforceOpportunityId(offerId)) {
    return `/offers/${offerId}`;
  }
  return '';
}
